import { Analytics } from '@util/Analytics';
import React, { ReactElement } from 'react';
import { isEmpty } from 'ts-utils';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { ActionType } from '../../store/ActionTypes';
import { useAppDispatch } from '../../store/Store';
import { NavigationProps } from './FlowNavigation';
import { PhoneNumberLayout, PhoneNumberLayoutConfig } from './layouts/PhoneNumberLayout';

export type PhoneNumberScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.PhoneNumber,
  PhoneNumberLayoutConfig,
  ScreenNames
>;

type PhoneNumberScreenProps<ScreenNames extends string> = NavigationProps<
  PhoneNumberScreenConfig<ScreenNames>,
  ScreenNames
>;

export const PhoneNumberScreen = <ScreenNames extends string>(
  props: PhoneNumberScreenProps<ScreenNames>
): ReactElement => {
  const dispatch = useAppDispatch();

  function handleSubmit(phoneNumber: string | undefined) {
    if (!isEmpty(phoneNumber)) {
      dispatch({ type: ActionType.SET_PHONE_NUMBER, phoneNumber });

      // Do not record the answer as phone number is PII data
      Analytics.track({
        event: Analytics.Event.o_question_answered,
        question: props.screenName,
      });
    }
    props.navigation.next(props);
  }

  return <PhoneNumberLayout {...props.layout} onSubmit={handleSubmit} />;
};
